import React from 'react'
import { ReactComponent as Benefit1Icon } from '@/assets/application-flow-skins/shared/download/download-benefit-1.svg'
import { ReactComponent as Benefit2Icon } from '@/assets/application-flow-skins/shared/download/download-benefit-2.svg'
import { ReactComponent as Benefit3Icon } from '@/assets/application-flow-skins/shared/download/download-benefit-3.svg'
import { ReactComponent as Benefit4Icon } from '@/assets/application-flow-skins/shared/download/download-benefit-4.svg'
import { ReactComponent as Step1Icon } from '@/assets/application-flow-skins/shared/download/download-step-1.svg'
import { ReactComponent as Step2Icon } from '@/assets/application-flow-skins/shared/download/download-step-2.svg'
import { ReactComponent as Step3Icon } from '@/assets/application-flow-skins/shared/download/download-step-3.svg'
import stepArrow from '@/assets/application-flow-skins/shared/download/download-step-arrow.svg'
import jhjBrandSlogan from '@/assets/application-flow-skins/shared/download/jhj-brand-slogan.png'
import arrow from '@imgs/download/arrows.svg'
import ApplicationFlowHeader from '../components/application-flow-header'
import { DownloadSkinProps } from '../types'
import themeStyles from '../theme/application-flow-theme.module.scss'
import styles from './download-skin.module.scss'

/**
 * DownloadSkin — 注册成功后的独立下载页展示皮肤，不拥有链接、下载或设备判断。
 * @returns {React.ReactElement} 下载页展示节点
 */
const DownloadSkin: React.FC<DownloadSkinProps> = React.memo(({
  model,
  onBack,
  onCloseWechatTip,
  onDownload,
  theme,
}) => {
  const downloadButtonText = model.isDownloadReady
    ? '下载APP 领取额度'
    : '下载链接准备中…'

  return (
    <main className={themeStyles.themeRoot} data-theme={theme.name}>
      <section className={styles.page}>
        {/* 100% 对齐 FlowDownload Hero 真实主题图与沉浸浮层 */}
        <img alt="" aria-hidden="true" className={styles.hero} height="354" src={theme.downloadHero} width="375" />
        {theme.downloadHeroOverlay ? (
          <img alt="" aria-hidden="true" className={styles.hero} height="354" src={theme.downloadHeroOverlay} width="375" />
        ) : null}

        {/* 沉浸式透明 Header 导航组件 */}
        <ApplicationFlowHeader onBack={onBack ?? (() => undefined)} title="下载APP" />

        <section className={styles.brandArea} aria-label={model.brandName}>
          {model.isJhjBrand ? (
            <img alt="" aria-hidden="true" className={styles.brandSlogan} height="24" src={jhjBrandSlogan} width="228" />
          ) : (
            <>
              <img alt="" className={styles.brandMark} height="38" src={theme.downloadBrandMark} width="38" />
              <div className={styles.brandTitleWrap}>
                <strong>{model.brandName}</strong>
                <span className={styles.divider} aria-hidden="true" />
                <span>正规品牌 真实可信</span>
              </div>
            </>
          )}
        </section>

        <div className={styles.resultCardWrapper}>
          <img alt="" aria-hidden="true" className={styles.badge} src={theme.downloadBadge} />
          <section className={styles.resultCard}>
            <h1>恭喜您！已通过初审</h1>
            <p>您的资质已超越98%用户</p>
            <div className={styles.amountPanel}>
              <span>预估可借额度(元)</span>
              <strong>50,000</strong>
              <p>最终可提现额度以机构最终审批为准</p>
              <button
                disabled={!model.isDownloadReady}
                onClick={onDownload}
                type="button"
              >
                {downloadButtonText}
              </button>
              <div className={styles.downloadSteps} aria-label="下载APP、实名认证、获得额度">
                <div className={styles.stepItem}>
                  <Step1Icon aria-hidden="true" className={styles.stepIcon} focusable="false" />
                  <span>下载APP</span>
                </div>
                <img alt="" aria-hidden="true" className={styles.stepArrow} src={stepArrow} />
                <div className={styles.stepItem}>
                  <Step2Icon aria-hidden="true" className={styles.stepIcon} focusable="false" />
                  <span>实名认证</span>
                </div>
                <img alt="" aria-hidden="true" className={styles.stepArrow} src={stepArrow} />
                <div className={styles.stepItem}>
                  <Step3Icon aria-hidden="true" className={styles.stepIcon} focusable="false" />
                  <span>获得额度</span>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section className={styles.benefits}>
          <div className={styles.benefitList}>
            <div className={styles.benefitItem}>
              <Benefit1Icon aria-hidden="true" className={styles.benefitIcon} focusable="false" />
              <strong>持牌合规</strong>
              <span>持牌机构</span>
              <span>合规经营</span>
            </div>
            <div className={styles.benefitItem}>
              <Benefit2Icon aria-hidden="true" className={styles.benefitIcon} focusable="false" />
              <strong>额度更高</strong>
              <span>最高可申</span>
              <span>20万</span>
            </div>
            <div className={styles.benefitItem}>
              <Benefit3Icon aria-hidden="true" className={styles.benefitIcon} focusable="false" />
              <strong>费率合规</strong>
              <span>年化利率</span>
              <span>7.2%-24%</span>
            </div>
            <div className={styles.benefitItem}>
              <Benefit4Icon aria-hidden="true" className={styles.benefitIcon} focusable="false" />
              <strong>分期灵活</strong>
              <span>支持3-36</span>
              <span>期自由分期</span>
            </div>
          </div>
        </section>

        {model.showWechatTip ? (
          <div className={styles.tipMask} onClick={onCloseWechatTip} role="presentation">
            <img alt="" aria-hidden="true" src={arrow} />
            <p>请点击右上角<br />选择"在浏览器打开"下载</p>
          </div>
        ) : null}
      </section>
    </main>
  )
})

DownloadSkin.displayName = 'DownloadSkin'

export default DownloadSkin
